import React, { FC, Fragment } from "react";
import { BsPatchQuestionFill } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { sidebarDetails } from "../environment";
import { List } from "@mui/material";

import ListSubheader from "@mui/material/ListSubheader";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";

type AdminSidebarProps = {
  side: any;
  handleside: any;
};
const AdminSidebar: FC<AdminSidebarProps> = ({
  side,
  handleside
}): JSX.Element => {
  const location = useLocation();
  return (
    <Fragment>
      <aside
        id="default-sidebar"
        className={` min-[1024px]:w-[262px] transition-transform -translate-x-full  lg:translate-x-0  shadow-2xl lg:flex w-0  ${
          side
            ? "max-lg:absolute   left-[0rem] top-0 bottom-0  duration-300 transition-transform translate-x-[0]   w-[40%] z-20 rounded-md min-[320px]:w-[222px]   sm:w-[222px] "
            : " "
        }`}
        aria-label="Sidebar"
      >
        <div className=" w-full h-full  px-0 overflow-y-auto bg-gray-50 ">
          <ul className="space-y-4 font-medium mt-2 ">
            {sidebarDetails.map((rest, index) => (
              <li key={index}>
                <Link
                  to={rest.navURL}
                  onClick={handleside}
                  className={`flex items-center ${
                    location.pathname === rest.navURL
                      ? "bg-gray-300"
                      : rest.nestedMenu.find(
                          (self:any) => self.navURL === location.pathname
                        )
                      ? "bg-gray-200"
                      : ""
                  }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
                >
                  <img src={rest.sideBarurl} className="w-6 h-6" />
                  <span className="flex-1 ms-3 whitespace-nowrap">
                    {rest.sidebarText}
                  </span>
                </Link>
                {rest.nestedMenu.length ? (
                  <>
                    <ul className="ml-4 mt-2">
                      {rest.nestedMenu.map((self:any, _index:number) => (
                        <li key={_index}>
                          <Link
                            to={self.navURL}
                            onClick={handleside}
                            className={`flex items-center ${
                              location.pathname === self.navURL
                                ? "bg-gray-300"
                                : ""
                            }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
                          >
                            <img src={self.sideBarurl} className="w-6 h-6" />
                            <span className="flex-1 ms-3 whitespace-nowrap">
                              {self.sidebarText}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <></>
                )}
              </li>
            ))}

            {/* <li>
              <Link
                to="/admin-dashboard/test-list"
                onClick={handleside}
                className={`flex items-center ${
                  location.pathname === "/admin-dashboard/test-list" ||
                  location.pathname === "/admin-dashboard/create-test"
                    ? "bg-gray-300"
                    : ""
                }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M9 16h.01M12 16h.01M15 16h.01M6 10V5a1 1 0 011-1h10a1 1 0 011 1v5M4 15.25a7.75 7.75 0 1115.5 0v.25a3.75 3.75 0 01-7.5 0v-.25"
                  />
                </svg>
                <span className="flex-1 ms-3 whitespace-nowrap">
                  Manage Test
                </span>
              </Link>
            </li>

            <li>
              <Link
                to="/admin-dashboard/result"
                onClick={handleside}
                className={`flex items-center ${
                  location.pathname === "/admin-dashboard/result" ||
                  location.pathname === "/admin-dashboard/result"
                    ? "bg-gray-300"
                    : ""
                }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
                  />
                </svg>

                <span className="flex-1 ms-3 whitespace-nowrap">Result</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </aside>
    </Fragment>
  );
};

export default AdminSidebar;
